(function () {
  'use strict';
  function destination(source, href, root, storedQid) {
    var page = new URL(href), prefix = (root || '/').replace(/\/$/, '');
    // Only Shopify's relative locale root is accepted; no external return URLs.
    if (!/^(?:|\/[a-z]{2}(?:-[A-Za-z]{2})?)$/.test(prefix)) prefix = '';
    var target = new URL(prefix + (source === 'cart' ? '/?cart=0' : '/collections/taste-profile'), page.origin);
    if (source !== 'cart') {
      var qid = page.searchParams.get('qid') || storedQid;
      if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(qid || '')) target.searchParams.set('qid', qid);
    }
    return target.pathname + target.search;
  }
  function knownEmail() {
    try {
      var email = (localStorage.getItem('wynch_login_email') || localStorage.getItem('winely_email') || '').trim();
      return email.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : '';
    } catch (_) { return ''; }
  }
  function withEmail(href) {
    var url = new URL(href, location.origin), email = knownEmail();
    if (url.origin !== location.origin) return href;
    if (email) url.searchParams.set('login_hint', email);
    return url.pathname + url.search + url.hash;
  }
  var source;
  function resultsPage() { return /\/(collections\/taste-profile|pages\/quiz(?:[-/]|$))/.test(location.pathname) || !!document.querySelector('[data-results-banner]'); }
  function getReturnTo(explicit) {
    var qid; try { qid = localStorage.getItem('winely_qid'); } catch (_) {}
    return destination(explicit || source || (resultsPage() ? 'quiz' : 'cart'), location.href, window.Shopify?.routes?.root || window.langify?.locale?.root_url || '/', qid);
  }
  window.WYNCH_AUTH_ROUTING = {destination: destination, getReturnTo: getReturnTo, isQuiz: function () { return source !== 'cart' && resultsPage(); }};
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var account = event.target.closest('#qa-header-button-account,#qa-header-button-account-mobile');
    // Header links use Shopify's native routes.account_url for both guests and customers.
    if (account) {
      if (account.dataset.wynchAuthenticated !== 'true' && knownEmail()) {
        account.href = withEmail(account.dataset.wynchLoginUrl || '/customer_authentication/login?return_to=%2Faccount');
      }
      return;
    }
    if (event.target.closest('#qa-cart-link-to-login,#qa-cart-link-to-register')) {
      source = 'cart';
      event.target.closest('#qa-cart-link-to-login,#qa-cart-link-to-register').href = withEmail('/customer_authentication/login?return_to=' + encodeURIComponent(getReturnTo('cart')));
    }
    else if (event.target.closest('.taste-profile-unregistered-controls,[data-results-banner]')) source = 'quiz';
    var link = event.target.closest('a[href]');
    if (link) {
      var url = new URL(link.href, location.origin);
      if (url.origin === location.origin && /\/customer_authentication\/login$/.test(url.pathname)) link.href = withEmail(link.href);
    }
  }, true);
})();
